import type { UseFormReset } from 'react-hook-form';
import { EndorsementPremiumChange } from '@domain/schemas/endorsement-premium-change';

import type { EndorsementFormState } from '../types';

export function resetForParentSubmission(
  reset: UseFormReset<EndorsementFormState> | undefined,
  parentSubmissionId?: string,
) {
  reset?.({ parentSubmissionId, premium_change: EndorsementPremiumChange.NONE });
}
